import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/base/ScrollToTop";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import LatestUpdates from "./components/LatestUpdates";
import HotRecommendations from "./components/HotRecommendations";
import FeaturedSection from "./components/FeaturedSection";

export default function Home() {
  useEffect(() => {
    document.title = "樱花漫画网 - 免费漫画与免费看漫画 | 免费韩漫、免费日漫、免费国漫在线全集";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "樱花漫画网提供海量免费漫画，涵盖免费韩漫、免费日漫、免费国漫，随时随地免费看漫画，追更不花一分钱。樱花漫画网、免费漫画、免费看漫画、免费韩漫、免费日漫、免费国漫、全集漫画、下拉式阅读、漫画在线、热门漫画推荐"
      );
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute("content", "樱花漫画网,免费漫画,免费看漫画,免费韩漫,免费日漫,免费国漫,全集漫画,下拉式阅读,漫画在线,热门漫画推荐");
    }
  }, []);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebSite",
              name: "樱花漫画网",
              url: window.location.origin,
              description:
                "樱花漫画网提供海量免费漫画，涵盖免费韩漫、免费日漫、免费国漫，随时随地免费看漫画，追更不花一分钱。",
              potentialAction: {
                "@type": "SearchAction",
                target: `${window.location.origin}/search?q={search_term_string}`,
                "query-input": "required name=search_term_string",
              },
            }),
          }}
        />
        <CategoryNav />
        <LatestUpdates />
        <HotRecommendations />
        <FeaturedSection />
      </main>
      <Footer />
    </>
  );
}